export default "__VITE_ASSET__Bu$Hn3zS__"